import * as React from "react";
const SvgJourneyGoal = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 3, strokeLinecap: "round", strokeLinejoin: "round", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5.25 12.75l4.5 4.5 9-10.5" }));
export default SvgJourneyGoal;
